import React from 'react'
import PropTypes from 'prop-types'
import { Spin } from '@pan/cloud-base'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import MainNavigation from './Navigation'
import MainContent from './MainContent'
import './InnerContent.scss'
import { PANW_ORANGE } from '../constants/ImageConstants'
import { getDefaultRoutePath } from '../utils/getDefaultPath'

const getSidebarNavItems = (routes) => (
  routes
    .filter(route => route.navPosition === 'left')
    .map(route => ({ path: route.navPath || route.path, text: route.text, icon: route.icon, subMenu: route.subMenu, hideSidebarNav: route.hideSidebarNav }))
)

const InnerContent = ({ appConfig, wrapperClassName, globalLoadingMask, globalLoadingMessage, appBarProps }) => {
  const { isVertical, hideAppBar = false } = appBarProps
  wrapperClassName = isVertical ? `vertical-app-bar-wrapper ${wrapperClassName}` : wrapperClassName
  return <div className={wrapperClassName}>
    <Spin
      spinning={hideAppBar ? false : globalLoadingMask}
      tip={globalLoadingMessage}
      className='pan-global-spin'
    >
      <MainNavigation
        navItems={isVertical ? getSidebarNavItems(appConfig.routes) : appConfig.routes
          .filter(route => route.navPosition && route.navPosition === 'top')
          .map(route => ({ path: route.navPath || route.path, text: route.text }))
          .concat(appConfig.settings.navItems || [])}
        navUtils={appConfig.settings.navUtils}
        name={appConfig.settings.name}
        isAppPortal={appConfig.settings.path === 'app'}
        logoImg={appConfig.settings.logo}
        logoImgCompact={appConfig.settings.logoCompact}
        hasSettings={appConfig.settings.hasSettings}
        hasUserAccountInfo={appConfig.settings.hasUserAccountInfo}
        navigateHome={appConfig.settings.navigateHome}
        defaultPath={getDefaultRoutePath(appConfig.routes)}
        helpLink={appConfig.settings.helpLink}
      />

      <MainContent
        showBadgeFooter={appConfig.settings.showBadgeFooter}
        appBarProps={appBarProps}
        routes={appConfig.routes}
        appInitAction={appConfig.settings.appInitAction}
        commonAddons={appConfig.settings.commonAddons}
      />
      { appConfig.settings.showBadgeFooter ? <div className={'show-footer'}>
        <div style={{ flex: 1 }} />
        <img src={ PANW_ORANGE } height={ 18 } style={{ margin: '7px 16px' }} alt='panw' />
      </div> : null }

    </Spin>
  </div>
}

InnerContent.propTypes = {
  appConfig: PropTypes.object,
  wrapperClassName: PropTypes.string,
  globalLoadingMask: PropTypes.bool,
  globalLoadingMessage: PropTypes.string,
  appBarProps: PropTypes.object
}
export default withRouter(connect(({ wrapperClassName, globalLoadingMask, globalLoadingMessage, appBarProps }) => ({ wrapperClassName, globalLoadingMask, globalLoadingMessage, ...appBarProps }))(InnerContent))
